var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"route-wrap page-inner"},[_c('Breadcrumb'),_vm._v(" "),_c('div',{staticClass:"content-wrap"},[_c('div',{staticClass:"article"},[_c('div',{staticClass:"content ql-editor",domProps:{"innerHTML":_vm._s(_vm.detail.contentDetails)}})]),_vm._v(" "),_c('Recommend')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7e5fa50","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Articles/index.vue
// module id = null
// module chunks = 